import React, {Fragment, useCallback, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {query, searchFacetChange} from '../Actions/FacetedSearch.action';
import FacetedSearchSlider from "./FacetedSearchSlider";
import FacetedSearchMultiSlider from "./FacetedSearchMultiSlider";
import {FacetedFilterDropdown} from "./Filters/FacetedFilterDropown";
import Tooltip from "./Tooltip";

const FacetedSearchGroup = ({group}) => {
    const showLessItemCount = useRef(5);
    const list = useRef(null);
    const showLess = useRef(null);
    const showMore = useRef(null);
    const dispatch = useDispatch();

    const {measurementType} = useSelector((state) => state.measurement);

    const measurementUnit = +measurementType === 1 ? "Imperial" : "Metric";

    function onFacetChange(group, item){
        dispatch(searchFacetChange(group, item));
    }
    
    if(group.options.length === 0){
        return null;
    }

    if(group.type === "MultiRangeSlider" && group.meta.measurementUnit !== measurementUnit) {
        return null;
    }

    return (<Fragment>
        <ul className="faceted-search__group" ref={list}>
            <div
                className="faceted-search__group-header"
                role="faceted-search-item-group"
            >
                {group.label}
                {group.description && <Tooltip inline={true} helpText={group.description}/>}
            </div>

            {group.type === "MultiRangeSlider" && <FacetedSearchMultiSlider group={group} onFacetChange={onFacetChange}/>}
            {group.type === "SingleSlider" && <FacetedSearchSlider group={group} onFacetChange={onFacetChange}/>}
            {group.type === "MultiDropdown" && <FacetedFilterDropdown group={group} onFacetChange={onFacetChange}/>}
            {!group.type &&  <Fragment>
                {group.options &&
                    group.options.map((item, itemIndex, array) => (
                        <li
                            key={`${item.label}-${itemIndex}`}
                            className="faceted-search__item"
                            role="menuitemcheckbox"
                            ref={(elem) => {
                                if (
                                    itemIndex ===
                                    showLessItemCount.current - 1
                                ) {
                                    showLess.current = elem;
                                }
                                if (itemIndex === array.length - 1) {
                                    showMore.current = elem;
                                }
                            }}
                        >
                            <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange}/>
                        </li>
                    ))}
            </Fragment>}
        </ul>
    </Fragment>);
};

const FacetedFilterCheckbox = ({item, group}) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch]
    );

    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={(event) => onChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {item.label}
            </span>
        </label>
    );
};

const FacetedSearch = () => {
    const dispatch = useDispatch();
    const {facetFilters, navigationTheme} = useSelector(
        (state) => state.facetedSearch
    );

    useEffect(() => {
        // listen to history events (back, forward) of window
        window.onpopstate =
            window.onpopstate ||
            ((event) => {
                dispatch(query(window.location.search.substr(1) || ''));
            });
    }, [dispatch]);

    return (
        navigationTheme !== 'category' &&
        facetFilters &&
        facetFilters.length > 0 && (
            <div className="faceted-search" role="menu">
                {facetFilters.map((group, groupIndex) => (
                    <FacetedSearchGroup
                        key={`${group.label}-${groupIndex}`}
                        group={group}
                    />
                ))}
            </div>
        )
    );
};

export default FacetedSearch;
